import COMPONENT_MAP from '../Repository/Components.js';
const file='SKUPickListPopup.js';

const SKUPickListPopup=({popupCallBack,application,userData,query})=>{
    const entityParams=[...(Array.isArray(query)?query.filter(Boolean):[]),`_lang=${application.globalData.lang}`,];

    const pageCallback=async(action,args)=>{
        if(action==='close_popup'){
            popupCallBack('closePopup',{});
        }
        else if(action==='selectRow'){
            popupCallBack('invokeMethod',{name:'selectRow',id:args?.id,pickMap:args?.pickMap});
        }
    }

    const renderPageList=()=>{
        const Component=COMPONENT_MAP['PageList'];
        return Component?(
            <Component
                userData={userData}
                application={application}
                entityType={'SKU'}
                entityParams={entityParams}
                file={file}
                height={'50vh'}
                list_name={'sku_picklist_popup'}
                filterComponent={null}
                title={application.getLocale("SKUsTitle")}
                pageCallback={pageCallback}
                canCreateNew={false}
                isLoading={false}
                focusOnSearchInput={true}
                button_actions={
                    [{name:'close_popup',label:'ButtonCancel',args:{}}]
                }
                isPopUp={true}
                defaultQuickSearchColumns={['name']}
            />
        ):null;
    };

    return (
        renderPageList()
    );
}

export default SKUPickListPopup;